import QuestionAlertsTypeSwitcher from './QuestionAlertsTypeSwitcher';
import { QuestionAlertsType } from './alertsType';

export { QuestionAlertsType };
export default QuestionAlertsTypeSwitcher;
